module.exports = __webpack_public_path__ + "img/parking-lot-3.68a01010.jpg";